// src/constants.ts
var SharedWorkerSupported = "SharedWorker" in globalThis;

export {
  SharedWorkerSupported
};
//# sourceMappingURL=chunk-R6SF5J3G.js.map